import styled from "styled-components";
import Box from "../../../elements/v2/Box/Box";

export const WhiteBox = styled(Box)`
  padding: 24px;
  background: white;
`;
